import { gql } from 'graphql-request';

import {
  CompanyEventTemplateID,
  CompanyEventTemplateNanoID,
  CompanyEventTemplateUUID
} from '../companyEventTemplatesTypes';

export interface FetchCacheSelectCompanyEventTemplateQueryResponse {
  id: CompanyEventTemplateID;
  nanoId: CompanyEventTemplateNanoID;
  uuid: CompanyEventTemplateUUID;
}

export const FETCH_CACHE_SELECT_COMPANY_EVENT_TEMPLATES_QUERY = gql`
  query CacheSelectCompanyEventTemplates(
    $filters: CompanyEventTemplatesFilters
    $sort: [CompanyEventTemplatesSortEnum]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    companyEventTemplates(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        id
        nanoId
        uuid
      }
      paginationInfo {
        nextPage
        totalCount
      }
      sql
    }
  }
`;
